import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';

import * as verifyEmail from '../../action-creators/verifyEmail';
import Loading from '../Loading';
import SecurityBoxLogo from '../SecurityBoxLogo';

const VerifyEmailContainer = translate(['ui'])(
  class extends React.Component {
    componentWillMount() {
      const { verifyToken, location } = this.props;

      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      // Path for redirect after login by email link
      const successRedirect = params.get('successRedirect');
      verifyToken(token, successRedirect);
    }

    // eslint-disable-next-line class-methods-use-this
    onClickHandler() {
      browserHistory.push('/login');
    }

    render() {
      const { verifyEmailError, t } = this.props;

      return (
        <div>
          {verifyEmailError ? (
            <div>
              <SecurityBoxLogo />
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: 'red', marginBottom: 15 }}>{t(verifyEmailError)}</div>
                <Button id="backHomeButton" onClick={this.onClickHandler} bsStyle="primary">
                  {t('Back to Home')}
                </Button>
              </div>
            </div>
          ) : (
            <Loading text={t('create_account_message')} />
          )}
        </div>
      );
    }
  }
);

function mapStateToProps(state) {
  return {
    verifyEmailError: state.main.getIn(['verifyEmail', 'error'])
  };
}

export default connect(mapStateToProps, verifyEmail)(VerifyEmailContainer);



// WEBPACK FOOTER //
// ./components/verifyEmail/verifyEmailContainer.jsx